export default __webpack_public_path__ + "static/media/logo.9d205124.svg";